import { lowerFirst } from 'lodash'
import React from 'react'

const displayNameValidator = (component: React.FC<any>) => {
  if (!component.displayName) {
    throw new Error('フィールドコンポーネントのdisplayNameを設定してください')
  }
  if (
    process.env.APP_ENV === 'development' ||
    process.env.APP_ENV === 'local'
  ) {
    const componentName = lowerFirst(component.name.replace('Field', ''))
    if (componentName !== component.displayName) {
      throw new Error(`${component.name}のdisplayNameに誤りがあります`)
    }
  }

  return component.displayName as string
}

export default displayNameValidator
